import { ConfirmationDialogComponent } from './../confirmation-dialog/confirmation-dialog.component';



import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { AppComponent } from './../../app.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { ExcelService } from './../../services/excel.service';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import { LoggerService } from 'src/app/services/logger.service';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
@Component({
  selector: 'app-manage-brokers',
  templateUrl: './manage-brokers.component.html',
  styleUrls: ['./manage-brokers.component.css'],
  providers: [DatePipe],
})
export class ManageBrokersComponent implements OnDestroy, OnInit {
  brokerList: Array<any> = [];

  dateFormat = 'YYYY-MM-DD';
  message: string
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  persons: Array<any> = [];

  loader: boolean
  dtTrigger: Subject<any> = new Subject<any>();
  dtTrigger1: Subject<any> = new Subject<any>();
  dtTrigger2: Subject<any> = new Subject<any>();
  dtTrigger3: Subject<any> = new Subject<any>();
  dtTrigger4: Subject<any> = new Subject<any>();



  customerslist: Array<any> = [];
  role: any;
  allBrokerList: any[];
  corporates: any;
  customerList: Array<any> = [];
  customerList1: Array<any> = [];
  countCustomerList: Array<any> = [];
  showViewButtonDisabled: boolean = false;
  showListButtonDisabled: boolean = false;
  customerListStatus: Array<any> = [];
  customersplanslist: Array<any> = [];
  selectedSubBroker: any;
  selectedForView: any;
  selectedPlanCustomer: any
  basicDetails: any;
  ParentName: any;
  brokerType: any;
  BrokerName: any;
  showdata: boolean = false
  subBrokers: any;
  showSubbroker: boolean
  disablesubBrokers: boolean = true
  disableCustomers: boolean = true
  isSubscribed: boolean;
  isAdvisor: boolean;
  checkboxesForMail: any;
  ccCheckboxesForMail: any;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  constructor(private logger: LoggerService, private formBuilder: FormBuilder, private route: ActivatedRoute, private http: HttpClient, public router: Router, private datePipe: DatePipe, private excelService: ExcelService,) { }
  ngOnInit() {
    this.getLanguageTokens()
    this.isSubscribed = false;
    this.loader = false
    this.role = sessionStorage.getItem('role');
    this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
      language: {
        searchPlaceholder: this.lang.Search_here
      },
      columnDefs: [
        {
          targets: '_all', // Index of the 'id' column
          orderable: false, // Disable sorting for this column
        },
      ],
    };
    this.getBrokerList()
    // this.getServiceWorkerDetails()

  }
  public getLanguageTokens(){
    let body= {
      "project":"Admin Portal",
      "url":"manageAdvisors"
    }
    this.http
    .post('https://languageengineapi.aitestpro.com/string/project-url-strings',body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .subscribe(
      (response: any) => {
        console.log(response)
        this.lang = {};
        this.languageData = response.strings
        this.selectedLanguage = sessionStorage.getItem("language")
        for (let token of response.strings) {
          this.lang[token.key] = token[this.selectedLanguage];
        }

        this.dtOptions = {
          pagingType: 'simple_numbers',
          order: [],
          language: {
            searchPlaceholder: this.lang.Search_here
          },
          columnDefs: [
            {
              targets: '_all', // Index of the 'id' column
              orderable: false, // Disable sorting for this column
            },
          ],
        };

      })


  }
  checkCount(c) {
    if (c > 0) { return false }
    return true
  }

  // getServiceWorkerDetails() {
  //   var getClients = '/api/ap/brokers/details';


  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + getClients,
  //     // fetch options
  //     options: {

  //       mode: 'cors',
  //       headers: {

  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   setTimeout(() => {
  //     postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {
  //       $("#dataTableId").dataTable().fnDestroy();

  //       // this._LoaderService.HideLoader()
  //       setTimeout(() => {
  //         this.brokerList = results[0].response.data

  //         this.allBrokerList = this.brokerList;

  //         this.brokerList.sort((a, b) => {

  //           const order = { true: 1, false: 2, };

  //           if (order[a.status] !== order[b.status]) {
  //             return order[a.status] - order[b.status];
  //           }
  //           return a.name.trim().localeCompare(b.name.trim());
  //         });

  //         this.dtTrigger.next(null);
  //       }, 500);
  //     })
  //   }, 1000);


  // }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger1.next(null);
    });
  }

  @ViewChild(ConfirmationDialogComponent) confirmationDialog: ConfirmationDialogComponent;

  invitationMail(id: any) {
    this.confirmationDialog.confirmed.subscribe(obj => {
      if (obj.confirmed) {
        var accessToken = sessionStorage.getItem('accessToken');
        var brokerStatus = '/api/ap/member/' + id + '/inviteMail/'
        this.logger.log('invition Id', id)


        this.http
          .get(environment.apiUrl + brokerStatus, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // this.getclientList()
                // window.location.reload()
                Swal.fire({ title: this.lang.Info, text: response.message })
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  // confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  if (result.isConfirmed) {
                  }
                  else {
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );

      }
    });
  }

  invitationAdvisor(broker: any) {
    this.isAdvisor = true
    // this.message = this.lang.Send +`${broker.name}`  +  this.lang.portal_access_link_to
    this.message = `${this.lang.Send} <b>${broker.name}</b> &nbsp;${this.lang.portal_access_link_to}`;

    const accessToken = sessionStorage.getItem('accessToken');

    function capitalizeWords(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }

    const getGroupContacts = `/api/ap/broker/${broker.id}/groupContact`;
    this.loader = true
    this.http.get(environment.apiUrl + getGroupContacts, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      this.loader = false
      if (response['status'] == 200 || response['statusCode'] == 200) {

        this.http.get(environment.apiUrl+'/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl+'/websocket/advisor/notification-to-others',{
            "message": "Advisors information has been updated. Please refresh screen."
          }, { headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          } }).subscribe((res)=>{
            console.log({res})
          })
        })

        const checkboxes = response.data.brokerAdmins
        if (checkboxes.length <= 0) {
          Swal.fire({ title: this.lang.Info, text: this.lang.Please_add_atleast_one_group_contact_to_send_the_Mail })
          return
        }
        this.ccCheckboxesForMail = broker.ccMails.map((c: any, i: number) => {
          const obj = {
            label: c,
            checked: false
          }
          return obj;
        })

        this.checkboxesForMail = checkboxes.map((c: any, i: number) => {
          const obj = {
            label: `${c.role == "ADVISOR_OTHERS" ? capitalizeWords(c.roleName) : c.roleNameDisplay || c.role} ${c.firstName} ${c.lastName} {${c.email}}`,
            checked: false,
            id: c.groupAdminId
          }
          return obj;
        }
        )
        this.adviserInvitation(broker)
      } else {
        Swal.fire({ title: this.lang.Error??'Error', text: response.message })
      }
    }), (error) => {
      this.loader = false
      Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
    }

    this.logger.log("checboxes", this.checkboxesForMail)

  }

  adviserInvitation(broker: any) {


    $('#confirmationModal').modal('show');
    if (!this.isSubscribed) {
      this.confirmationDialog.confirmed.subscribe(obj => {
        this.isSubscribed = true;
        if (obj.confirmed) {
          this.logger.log(obj)
          const payload = {
            groupAdmins: obj.selectedCheckboxes.map((o, i) => (o.id)),
            ccList: obj.selectedCcCheckboxes.map((o) => (o.label))
          }

          var accessToken = sessionStorage.getItem('accessToken');
          var GetBrokers = `/api/ap/broker/${broker.id}/invitation`;

          this.http
            .post(environment.apiUrl + GetBrokers, payload, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200 || response['statusCode'] == 200) {

                  Swal.fire({ title: this.lang.Info, text: response.message })
                } else {
                  Swal.fire({ title: this.lang.Error??'Error', text: response.message })
                }
              },
              (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: this.lang.Error??'Error',
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: this.lang.Proceed,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                  });
                } else {
                  // Swal.fire(error.error.error.message)
                  Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
                }
                // this.toastrService.error("Invalid Credentials", 'Error!');
              }
            );
        }
        $('#confirmationModal').modal('hide');
      })
    }
  }

  viewsubBrokerList(brokerlist, filter: any, brokerName: string, brokerId: any) {
    this.selectedForView = brokerName.length > 80 ? brokerName.substring(0, 80) + '...' : brokerName
    this.customerList = []

    if (filter == 'viewAll') {
      this.showSubbroker = true
      $('#subGroupList-modal').modal('show');
      this.logger.log(brokerlist);

      brokerlist.sort((a, b) => {
        const order = { 'TPA/MGA': 1, STUDENT_ASSOCIATION: 2, BROKERAGE: 3, ASSOCIATION: 4, ADVISOR: 5, CORPORATE: 6 };
        if (order[a.brokerType] !== order[b.brokerType]) {
          return order[a.brokerType] - order[b.brokerType];
        }
        return a.name.trim().localeCompare(b.name.trim())
      });
      this.customerslist = brokerlist;
    }

    else if (filter == 'corporates') {
      this.showSubbroker = false
      $('#subGroupList-modal').modal('show');
      this.corporates = brokerlist.filter(broker => broker.brokerType.toLowerCase() == 'corporate');
      this.corporates.sort((a, b) => a.name.localeCompare(b.name));
      this.customerslist = this.corporates;
      this.logger.log({ corp: this.customerList })
    }

    this.dtTrigger1.next(null);


    this.logger.log(this.showSubbroker)
  }

  public viewBrokerCustomers(broker: any, index: number) {
    this.logger.log({ broker })
    this.disablesubBrokers = false
    this.selectedSubBroker = broker.name.length > 80 ? broker.name.substring(0, 80) + '...' : broker.name

    $('#customersList').modal('show')

    // $('#DataTables_Table_1').dataTable().fnDestroy();
    $('#DataTables_Table_2').dataTable().fnDestroy();
    this.customerList1 = []
    this.getCustomerDetails(broker.id)
  }

  gotomemberDetails(customer:any){


    $('#customersList').modal('hide')
    $('#subGroupList-modal').modal('hide');
    $('#countList').modal('hide')

    this.router.navigate(['/manageMembers/employee/' + customer.uId + '/details']);

  }

  naviagtetoportal(broker:any){
    $('#subGroupList-modal').modal('hide');

    if(broker.brokerType=="ADVISOR"){
      this.router.navigate(['/manageAdvisors/' + broker.id + '/viewAdvisor']);
    }
    if(broker.brokerType=="CORPORATE"){
      // this.router.navigate(['/manageCorporates/' + broker.id + '/view']);
      // console.log(broker)

      const showTiles = broker.adminApproved;
      if (showTiles) {
        this.router.navigate(['/manageCorporates/' + broker.id + '/view']);
      } else {
        this.router.navigate(['/manageCorporates/edit-corporate/' + broker.id]);
      }

    }
  }
  getCustomerDetails(brokerId) {

    var accessToken = sessionStorage.getItem('accessToken');
    // /api/ap / broker / 10 / customers / details'
    var GetBrokersDetails = '/api/ap/broker/' + brokerId + '/customers/details';

    this.http
      .post(environment.apiUrl + GetBrokersDetails, {}, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {

            this.logger.log(response.data.customers)
            this.customerList = response.data.employees
            this.basicDetails = response.data
            this.ParentName = this.basicDetails?.parent?.name
            this.brokerType = this.basicDetails.brokerType
            this.BrokerName = this.basicDetails.name
            this.showdata = true
            if (this.customerList.length < 0) {
              this.showViewButtonDisabled = true
            }
            var arr = []

            for (let i = 0; i < this.customerList.length; i++) {
              arr.push(this.customerList[i].status)
              this.customerListStatus = arr.filter((item,
                index) => arr.indexOf(item) === index);
              if (this.customerList[i].status == "Active") {
                this.customerList1.push(this.customerList[i])
              }
              this.customerList1 = this.customerList1.sort((a, b) => (a.firstName.trim().localeCompare(b.firstName.trim())));


            }

            this.logger.log("customerlist", this.customerList1)

            $("#DataTables_Table_2").dataTable().fnDestroy();
            this.dtTrigger2.next(null);

          }
          else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
        }
      );
  }

  viewsupersubbrokerList(broker) {
    this.disablesubBrokers = false
    this.subBrokers = []
    this.selectedSubBroker = broker.name.length > 80 ? broker.name.substring(0, 80) + '...' : broker.name
    this.getSuperSubBrokers(broker)
    $("#supersubList-modal").modal('show')


  }

  getSuperSubBrokers(broker) {
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokers = `/api/ap/broker/${broker.id}/subBrokers`;
    this.http
      .get(environment.apiUrl + GetBrokers, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.subBrokers = response.data.subBrokers.sort((a, b) => (a.name.trim().localeCompare(b.name.trim())))
            if (this.subBrokers.length < 1) {
              this.showListButtonDisabled = true;
            }
            else {
              this.showListButtonDisabled = false;

            }
            this.logger.log("subBrokers", this.subBrokers, "length", this.subBrokers.length, this.showListButtonDisabled)
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }



  getCountCustomers(brokerId, subBrokerIds) {

    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokersDetails = '/api/ap/brokers/customers';
    let data = { brokerIds: [brokerId, ...subBrokerIds] }
    // var GetBrokersDetails = '/api/ap/broker/' + 1044 + '/details';


    this.http
      .post(environment.apiUrl + GetBrokersDetails, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {

            this.logger.log(response.data.employees)
            this.countCustomerList = response.data.employees.sort((a, b) => {
              const order = { Active: 1, Incomplete: 2, Hold: 3, Cancelled: 4, Draft: 5, Suspended: 6 };

              if (order[a.status] !== order[b.status]) {
                return order[a.status] - order[b.status];
              }
              return a.firstName.trim().localeCompare(b.firstName.trim());
            });



            $("#DataTables_Table_4").dataTable().fnDestroy();
            this.dtTrigger4.next(null);

          }
          else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
        }
      );
  }

  viewCountCustomers(brokerName: any, brokerId: any, subBrokerIds: any) {
    this.logger.log({ brokerName })
    this.selectedSubBroker = brokerName.length > 80 ? brokerName.substring(0, 80) + '...' : brokerName

    $('#countList').modal('show')


    this.getCountCustomers(brokerId, subBrokerIds)
  }

  viewcustomerPlansList(brokerlist, firstName, lastName) {
    this.logger.log({ brokerlist })
    this.disableCustomers = false;
    this.selectedPlanCustomer = `${firstName} ${lastName}`

    $('#customerPlansList-modal').modal('show');

    this.customersplanslist = brokerlist

    $("#DataTables_Table_3").dataTable().fnDestroy();
    this.dtTrigger3.next(null);

  }

  closePopup() {
    $("#DataTables_Table_1").dataTable().fnDestroy();
  }


  closeplansList() {
    this.disableCustomers = true;
    $("#DataTables_Table_3").dataTable().fnDestroy();
  }

  closeCountList() {
    // $("#DataTables_Table_4").dataTable().fnDestroy();
  }


  closeGigList() {
    $("#DataTables_Table_1").dataTable().fnDestroy();
    this.dtTrigger.next(null);
  }

  changeStatus(e: any) {
    $("#dataTableId").dataTable().fnDestroy();
    this.brokerList = [];

    let val = e.target.value.toLowerCase();//member.status.toLowerCase()==val
    if (val == 'all') {
      this.brokerList = this.allBrokerList;
    } else {
      this.brokerList = this.allBrokerList.filter((member) => {
        if (member.status?.toString().toLowerCase() == val) {
          return member;
        }
      });
    }
    // this.dtTrigger.next(null);
    // this.dtTrigger.unsubscribe();
    this.dtTrigger.next(null);
    this.logger.log(this.brokerList);
  }

  public viewBrokerDetails(broker: any, index: number) {

    // this.router.navigate(['/manageAdvisors/editAdvisor/' + broker.id]);
    this.router.navigate(['/manageAdvisors/' + broker.id + '/viewAdvisor']);


    // /broker/{brokerId}/details

  }


  public addBrokerDetails() {
    this.router.navigate(['/manageAdvisors/addAdvisor']);

  }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  public getBrokerList() {

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokers = '/api/ap/brokers/details';
    const that = this;

    this.loader = true;
    this.http
      .get(environment.apiUrl + GetBrokers, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          this.loader = false;
          if (response['status'] == 200 || response['statusCode'] == 200) {




            setTimeout(() => {
              this.brokerList = (response as any).data;

              this.allBrokerList = this.brokerList;
              // this.brokerList=this.brokerList.sort((a, b)=>{
              //   const order={true :1,false:2};
              //   return order[a.status]-order[b.status]
              // })
              this.brokerList.sort((a, b) => {

                const order = { true: 1, false: 2, };

                if (order[a.status] !== order[b.status]) {
                  return order[a.status] - order[b.status];
                }
                return a.name.trim().localeCompare(b.name.trim());
              });

              this.dtTrigger.next(null);
            }, 500);




          } else {
            this.loader = false;
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          this.loader = true;
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  public deletebrokerDetails(broker: any, index: any) {

    this.logger.log(broker)
    // this.logger.log(index)
    var accessToken = sessionStorage.getItem('accessToken');
    var deleteBroker = '/api/ap/broker/' + broker.id + ''


    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this + broker.brokerType + '?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .delete(environment.apiUrl + deleteBroker, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // this.dtTrigger.next("");
                window.location.reload()
                // this.getBrokerList()
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
    })

  }

  public brokerStatus(broker: any, event: any, index: number) {
    $("#dataTableId").dataTable().fnDestroy();

    var accessToken = sessionStorage.getItem('accessToken');
    var brokerStatus = '/api/ap/broker/' + broker.id + '/activation/' + event

    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_change_this + broker.brokerType + this.lang.status+"?",
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .get(environment.apiUrl + brokerStatus, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // window.location.reload()
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
      else {
        this.getBrokerList()
        // window.location.reload()
      }
    })

  }


  closeCustomersList() {
    // $("#DataTables_Table_2").dataTable().fnDestroy();
    this.disablesubBrokers = true
    // this.dtTrigger1.next(null);
  }

  closeSuperSubList() {
    // $("#DataTables_Table_1").dataTable().fnDestroy();
    this.disablesubBrokers = true
    // this.dtTrigger1.next(null);
  }


  filtercustomerstatus(e, status) {
    this.logger.log(e)
    this.logger.log(e.target.value)

    $("#DataTables_Table_2").dataTable().fnDestroy();
    this.dtTrigger2.next(null);

    if (e.target.value != "All") {
      this.customerList1 = []
      for (let i = 0; i < this.customerList.length; i++) {
        if (this.customerList[i].status == e.target.value) {
          this.customerList1.push(this.customerList[i])
        }
      }
      this.customerList1 = this.customerList1.sort((a, b) =>
        a.firstName > b.firstName ? 1 : -1
      );
    }
    else {
      this.customerList1 = this.customerList.sort((a, b) =>
        a.firstName > b.firstName ? 1 : -1
      );
    }
  }





  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}
export function moments(date: string | undefined): moment.Moment {

  if (date)

    return moment((new Date(date)).toJSON())

  else

    return moment();

}
